<template>
    <div class='live-list'>
        <div class="body">
            <div class="header-box clearfix">
                <div class="room-name floatL">
                    {{roomName(roomValue)}}
                </div>
                <div class="select-box floatR">
                    <el-select class="mr20" v-model="roomValue" @change="search()">
                        <el-option v-for="item in roomList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="play-box">
                <!-- <div class="video-box"> -->
                <vue-aliplayer-v2 v-if="playerOptions.source" @error="playError" @ready="playReady" style="height:100%" :source="playerOptions.source" ref="VueAliplayerV2" :options="playerOptions"></vue-aliplayer-v2>
                <div v-else class="no-select">当前食堂暂无视频监控</div>
                <!-- </div> -->
            </div>
            <div class="list-box clearfix" v-loading="cameraListLoading" v-if="pagination.total > 0">
                <div class="title">视频监控（摄像头数：{{pagination.total || 0}}）</div>
                <div class="list">
                    <div :class="`list-item floatL ${item.id === selectVideo.id? 'select' : ''}`" v-for="item in cameraList" :key="item.id" @click="selectShow(item)">
                        <div class="img-box">
                            <img :src="item.coverUrl || defaultImg" />
                            <div class="mask">
                                <img src="../../../assets/img/play_icon.png" alt="">
                            </div>
                        </div>
                        <div class="text">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <div class="page-box" v-if="pagination.total > 0">
                <el-pagination class="floatR" v-bind="pagination" @size-change="pageSizeChange" @current-change="pageCurrentChange"> </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import VueAliplayerV2 from 'vue-aliplayer-v2';

import * as api from '../../../api/camera';
import defaultImg from '../../../assets/img/default.png';

export default {
    components: { VueAliplayerV2 },
    data() {
        return {
            defaultImg,
            cameraListLoading: false,
            selectVideo: '', // 当前选中展示的视频
            roomList: [],
            cameraList: [],
            roomValue: "",
            pagination: {
                layout: "total, sizes, prev, pager, next, jumper",
                total: 0,
                pageSize: 10,
                pageSizes: [10, 20, 30, 40, 50],
                currentPage: 1,
                background: true,
            },
            playerOptions: {
                cover: '',
                source: '',
                isLive: true,   //切换为直播流的时候必填
                format: 'm3u8',  //切换为直播流的时候必填
                // skinLayout: false,
                autoplay: true,

            },
        };
    },
    mounted() {
        api.getSubList().then(data => {
            if (data.code === 200) {
                this.roomValue = data.data && data.data[0].id;
                this.roomList = this.roomList.concat(data.data);
                this.search()
            }
        })
    },
    methods: {
        search(page = 1) {
            this.cameraListLoading = true;
            let data = {
                pageNum: page,
                pageSize: this.pagination.pageSize,
                subCanteen: this.roomValue,
            }
            this.pagination.currentPage = page;

            return api.getLiveCameraList(data)
                .then(data => {
                    this.cameraList = data.data.records;
                    this.pagination.total = data.data.total

                    if (data.code === 200 && data.data.records.length > 0) {
                        this.selectShow(data.data.records[0]);
                    } else {
                        this.playerOptions.source = ""
                    }

                    return data;
                })
                .finally(data => {
                    this.cameraListLoading = false;
                    return data;
                })
        },
        pageSizeChange(currentPageSize) {
            this.pagination.pageSize = currentPageSize;
            this.search();

        },
        pageCurrentChange(currentPage) {
            this.pagination.currentPage = currentPage;
            this.search(currentPage);
        },
        // 播放视频
        selectShow(record) {
            this.selectVideo = record;
            this.playerOptions.source = record.videoUrl;
            this.playerOptions.cover = record.coverUrl;
        },
        roomName(roomId) {
            for (let index = 0; index < this.roomList.length; index++) {
                if (this.roomList[index].id === roomId) {
                    return this.roomList[index].name;
                }
            }
        },
        playError(event) {
            if (event.paramData.error_code === 4006) {
                this.$message.error(`播放错误！不能成功连接播放地址`)
            } else {
                this.$message.error(`播放错误！${event.paramData.display_msg}`)
            }
        },
        playReady() {
            this.$refs.VueAliplayerV2.play();
        }
    }
};
</script>

<style lang='scss'>
.live-list {
    padding: 20px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    > .body {
        padding: 20px 30px;
        width: 100%;
        min-height: 100%;
        background-color: #fff;
        border-radius: 10px;
        box-sizing: border-box;
    }
    .header-box {
        padding-bottom: 20px;
        .room-name {
            font-size: 20px;
            line-height: 32px;
        }
    }
    .play-box {
        height: 500px;
        .no-select {
            line-height: 500px;
            text-align: center;
            font-size: 30px;
            font-weight: 600;
            color: #ccc;
        }
        // position: relative;
        // left: 0;
        // top: 0;
        // padding-bottom: 20px;
        // background-color: #fff;
        // .video-box {
        //     position: relative;
        //     left: 0;
        //     right: 0;
        //     margin: 0 auto;
        //     width: 1000px;
        // }
    }
    .list-box {
        padding: 0 20px;
        min-height: 300px;
        .title {
            padding-top: 20px;
            font-size: 20px;
        }
        .list {
            margin-left: -50px;
            .list-item {
                margin-top: 20px;
                margin-left: 60px;
                width: 250px;
                height: 200px;
                cursor: pointer;
                &:hover {
                    .mask {
                        opacity: 1;
                    }
                }
                &.select,
                &:hover {
                    .img-box::after {
                        display: block;
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 0;
                        border: 3px solid #02a7f0;
                        z-index: 2;
                    }
                    .img-box::before {
                        display: block;
                        content: "";
                        position: absolute;
                        top: 10px;
                        left: 15px;
                        box-shadow: 0px 0px 5px 3px #bbb,
                            0px 0px 5px 3px #bbb inset;
                        background-color: transparent;
                        z-index: 1;
                    }
                }

                .img-box {
                    position: relative;
                    width: 100%;
                    height: 160px;
                    &::after,
                    &::before {
                        transition: 0.7s;
                        height: 100%;
                        width: 100%;
                        box-sizing: border-box;
                    }
                    > img {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        width: 100%;
                        height: 100%;
                    }
                }
                .text {
                    margin-top: 20px;
                    text-align: center;
                    font-size: 16px;
                }
                .mask {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 3;
                    opacity: 0;
                    transition: 0.7s;
                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        margin: auto;
                        width: 44px;
                        height: 44px;
                    }
                }
            }
        }
    }

    .page-box {
        padding: 50px 0;
    }
}
</style>